import { ReactElement, useState } from 'react';
import {
  IconButton,
  sourceNiceName,
  SourceIcon,
} from '@sc/shared-ui';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useSuspenseQuery } from '@apollo/client/react';
import { ProjectState } from '@sc/graphql';
import classNames from 'classnames';
import { GQL_QUERY_INDEX_SOURCES } from '../utility/queries';
import { SourceDocuments } from './SourceDocuments';

export const ProjectSources = ({
  projectUuid,
  state,
}: {
  projectUuid: string;
  state: ProjectState;
}): ReactElement => {

  const { data } = useSuspenseQuery(GQL_QUERY_INDEX_SOURCES, {
    variables: {
      projectUuid,
    },
  });

  const [showSourceDocuments, setShowSourceDocuments] = useState<string | null>(
    null
  );

  return (
    <>
      {data.indexSources.map((s) => (
        <div className="mt-2 space-y-2" key={s.uuid}>
          <div className="flex items-center space-x-2 mx-5">
            <SourceIcon className="text-grey-400 size-5" type={s.type} />
            <span className="grow">
              {s.name ?? sourceNiceName[s.type]} ({s.documentCount})
            </span>
            <IconButton
              onClick={() =>
                setShowSourceDocuments((show) =>
                  show === s.uuid ? null : s.uuid
                )
              }
              tooltipId={s.uuid}
              Icon={showSourceDocuments === s.uuid ? EyeIcon : EyeSlashIcon}
              tooltip={`${
                showSourceDocuments === s.uuid ? 'Hide' : 'Show'
              } source documents`}
            />
          </div>
          <div className="max-h-75 overflow-hidden flex flex-col">
            <div className="overflow-y-auto px-5 space-y-2">
              {showSourceDocuments === s.uuid && (
                <SourceDocuments state={state} sourceUuid={s.uuid} />
              )}
            </div>
          </div>
          <hr
            className={classNames(
              'h-px border-none bg-grey-t-800 transition-all duration-100',
              {
                'mt-2': showSourceDocuments !== s.uuid,
                'mt-5': showSourceDocuments === s.uuid,
              }
            )}
          />
        </div>
      ))}
    </>
  );
};
